import axios from 'axios';
import * as Sentry from "@sentry/vue";
import {
  API_URL,
  EVENT_CREATE, EVENT_DELETE,
  EVENT_DETAIL, EVENT_EDIT,
  EVENT_ERROR,
  EVENT_REQUEST,
  EVENT_SUCCESS, POSTAL_CODE_REQUEST,
  SET_EVENT_DETAIL,
  SET_EVENTS,
  SET_NOTIFICATION, SET_POSTAL_CODE, UPDATE_EVENT_PICTURE, UPDATE_EVENT_TAGS
} from "@/store/constant";
import { splitLocationText } from "@/helpers";

const state = { events: null, status: null, eventDetail: null, postalCode: null, };

const getters = {
  events: state => state.events,
  eventStatus: state => state.status,
  eventDetail: state => state.eventDetail,
  postalCode: state => state.postalCode,
};

const actions = {
  [EVENT_REQUEST]: ({ commit }) => {
    commit(EVENT_REQUEST);
    commit(SET_EVENTS, null);
    axios({ url: `${API_URL}/events-me` })
      .then(resp => {
        commit(EVENT_SUCCESS);
        commit(SET_EVENTS, resp.data);
      })
      .catch(err => {
        commit(EVENT_ERROR);
        commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
        Sentry.captureException(err);
      });
  },
  [EVENT_CREATE]: ({ commit }, data) => {
    commit(EVENT_REQUEST);
    return new Promise((resolve, reject) => {
      axios.post(`${API_URL}/events-me`, data)
        .then(resp => {
          commit(EVENT_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['イベントが作成されました。'] });
          resolve(resp)
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages || [err.response.data.message] });
          commit (EVENT_ERROR);
          reject(err);
          Sentry.captureException(err);
        });
    });
  },
  [EVENT_DETAIL]: ({ commit }, id) => {
    commit(EVENT_REQUEST);
    commit(SET_EVENT_DETAIL, null);
    axios({ url: `${API_URL}/events-me/${id}` })
      .then(resp => {
        commit(EVENT_SUCCESS);
        resp.data.addressType = resp.data.address ?'address' :'location';
        const locationData = splitLocationText(resp.data.location);
        resp.data.prefecture = locationData ?locationData.prefecture :null;
        resp.data.locationFreeText = locationData ?locationData.freeLocationText :null;
        resp.data.cityFromPostalCode = resp.data.address ?resp.data.location :null;
        commit(SET_EVENT_DETAIL, resp.data);
      })
      .catch(err => {
        commit(EVENT_ERROR);
        commit(SET_NOTIFICATION,{ type: 'error', messages: [err.response.data.message] });
        Sentry.captureException(err);
      });
  },
  [EVENT_EDIT]: ({ commit }, data) => {
    commit(EVENT_REQUEST);
    return new Promise((resolve, reject) => {
      axios.put(`${API_URL}/events-me/edit/${data.id}`, data.formData)
        .then(resp => {
          commit(EVENT_SUCCESS);
          commit(SET_NOTIFICATION,{ type: 'info', messages: ['イベントが更新されました。'] });
          resolve(resp)
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages || [err.response.data.message] });
          commit (EVENT_ERROR);
          reject(err);
          Sentry.captureException(err);
        });
    });
  },
  [EVENT_DELETE]: ({ commit }, id) => {
    commit(EVENT_REQUEST);
    return new Promise((resolve, reject) => {
      axios.delete(`${API_URL}/events-me/${id}`)
        .then(resp => {
          commit(SET_NOTIFICATION, { type: 'info', messages: ['イベントが削除されました。'] });
          resolve(resp);
        })
        .catch(err => {
          commit(SET_NOTIFICATION, { type: 'error', messages: err.response.data.message[0].messages || [err.response.data.message] });
          reject(err);
          Sentry.captureException(err);
        })
    })
  },
  [POSTAL_CODE_REQUEST]: ({ commit }, postalCode) => {
    return new Promise((resolve, reject) => {
      axios({ url: `${API_URL}/postal-codes?code=${postalCode}` })
        .then(resp => {
          resolve(resp);
        })
        .catch(err => {
          commit(SET_NOTIFICATION,{ type: 'error', messages: err.response.data.message[0].messages });
          reject(err);
          Sentry.captureException(err);
        });
    });
  }
};

const mutations = {
  [EVENT_REQUEST]: state => {
    state.status = 'loading';
  },
  [EVENT_SUCCESS]: state => {
    state.status = 'success';
  },
  [EVENT_ERROR]: state => {
    state.status = 'error';
  },
  [SET_EVENTS]: (state, payload) => {
    state.events = payload;
  },
  [SET_EVENT_DETAIL]: (state, payload) => {
    state.eventDetail = payload;
  },
  [UPDATE_EVENT_PICTURE]: (state, payload) => {
    state.eventDetail.media = payload;
  },
  [UPDATE_EVENT_TAGS]: (state, payload) => {
    state.eventDetail.tags = payload;
  },
}

export default {
  state,
  getters,
  actions,
  mutations
};
